import { Button } from '@mui/material'
import React, { useState, useRef, useEffect, useContext } from 'react'
// import CustomInput from '../../atoms/Inputs/CustomInput'
// import PrimaryButton from '../../atoms/PrimaryButton'
import {
    currencyFormat,
    dateFormatFunction,
    timeFormatFunction,
    hoursMinutesFormateFunction,
} from '../../custom/common/components'

const CartItem = (props) => {
    const [product, setProduct] = useState()

    useEffect(() => {
        setProduct(props.data)
    }, [props.data])

    return (
        <>
            {product ? (
                <>
                    <div className="cartItem d-flex justify-content-between align-items-start">
                        <div className="itemInfo d-flex justify-content-start">
                            <div className="pclImg">
                                <img
                                    src={
                                        global.site_url +
                                        '/uploads/product/' +
                                        product.projects_avatar
                                    }
                                    alt={product.title}
                                    onError={(e) => {
                                        e.target.onerror = null // prevent infinite loop
                                        e.target.src = `/assets/images/noImg.png`
                                    }}
                                />
                            </div>
                            <div className="listContent">
                                <h2 className="listProdTitle">
                                    {product.projects_title}
                                </h2>
                                {props.from == 'buynowcart' ||
                                props.from == 'buynowcheckout' ||
                                (props.from == 'invoice' &&
                                    product.buynow_autype === 'buynow') ? (
                                    <>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    Winning Offer Amount:
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    Time to Give Network Fee:
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_tax
                                                    )}
                                                </span>
                                            </h5>
                                        </div>

                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Charity Name:</span>
                                                <span>
                                                    {
                                                        product.custom_projects_charity_name
                                                    }
                                                </span>
                                            </h5>
                                        </div>
                                        {product.custom_projects_meeting_venue && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Meeting venue'}:
                                                    </span>{' '}
                                                    <span>
                                                        {
                                                            product.custom_projects_meeting_venue
                                                        }
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product?.custom_projects_meeting_datetime && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Date :</span>
                                                    <span>
                                                        {dateFormatFunction(
                                                            product.custom_projects_meeting_datetime
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product.custom_projects_meeting_datetime && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Time :</span>
                                                    <span>
                                                        {' '}
                                                        {timeFormatFunction(
                                                            product.custom_projects_meeting_datetime,
                                                            'hh:mm A'
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product.custom_projects_meeting_duration >
                                            0 && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Duration'}:</span>{' '}
                                                    <span>
                                                        {' '}
                                                        {hoursMinutesFormateFunction(
                                                            product.custom_projects_meeting_duration
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                    </>
                                ) : props.from == 'cart' ||
                                  props.from == 'checkout' ||
                                  (props.from == 'invoice' &&
                                      product.buynow_autype === 'auction') ||
                                  product.buynow_autype === 'live' ? (
                                    <>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    Winning Offer Amount:
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.per_total
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>
                                                    Time to Give Network Fee:
                                                </span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_tax
                                                    )}
                                                </span>
                                            </h5>
                                        </div>

                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Total:</span>
                                                <span>
                                                    {currencyFormat(
                                                        product.total_amount
                                                    )}
                                                </span>
                                            </h5>
                                        </div>
                                        <div className="listLotInfo d-flex justify-content-start align-items-center">
                                            <h5>
                                                <span>Charity Name:</span>

                                                <span>
                                                    {
                                                        product.custom_projects_charity_name
                                                    }
                                                </span>
                                            </h5>
                                        </div>
                                        {product.custom_projects_meeting_venue && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>
                                                        {'Meeting venue'}:
                                                    </span>{' '}
                                                    <span>
                                                        {
                                                            product.custom_projects_meeting_venue
                                                        }
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product?.custom_projects_meeting_datetime && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Date :</span>
                                                    <span>
                                                        {dateFormatFunction(
                                                            product.custom_projects_meeting_datetime
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product.custom_projects_meeting_datetime && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>Time :</span>
                                                    <span>
                                                        {' '}
                                                        {timeFormatFunction(
                                                            product.custom_projects_meeting_datetime,
                                                            'hh:mm A'
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                        {product.custom_projects_meeting_duration >
                                            0 && (
                                            <div className="listLotInfo d-flex justify-content-start align-items-center">
                                                <h5>
                                                    <span>{'Duration'}:</span>{' '}
                                                    <span>
                                                        {' '}
                                                        {hoursMinutesFormateFunction(
                                                            product.custom_projects_meeting_duration
                                                        )}
                                                    </span>
                                                </h5>
                                            </div>
                                        )}
                                    </>
                                ) : null}
                            </div>
                        </div>

                        <div className="listActBtn"></div>
                    </div>
                </>
            ) : null}
        </>
    )
}
export default CartItem
